export const REFRESH_TOKEN_INTERVAL_MS = 900001;

export * from './storageKeys';
export { AUTH_EVENTS } from './events';
export type { AuthEventName } from './events';
